import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalendar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M6.75 1.75v2m0 1.5v-1.5m6.5-2v2m0 1.5v-1.5m-6.5 0h-3a2 2 0 0 0-2 2v10.5a2 2 0 0 0 2 2h12.5a2 2 0 0 0 2-2V5.75a2 2 0 0 0-2-2h-3m-6.5 0h6.5m-11.5 5h16.5"
	})]
});
const ForwardRef = forwardRef(SvgCalendar);
export { ForwardRef as ReactComponent };
